export default "__VITE_ASSET__tsZNV18S__"